import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TopBar } from "../components/TopBar";
import { AppShell } from "../components/Shell";
import { useAuth } from "../context/AuthContext";
import { errorMessage } from "../lib/api";
import { useT } from "../i18n";

export default function Login() {
  const { login } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await login(form);
      navigate(data.has_profile ? "/recherche" : "/onboarding");
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AppShell narrow>
      <TopBar compact onBack={() => navigate("/")} />
      <main className="px-5 pb-12 pt-6 stagger" data-testid="login-page">
        <h1 className="h-display text-5xl">
          {t("login_h1a")}
          <br />
          <span className="text-rox-orange">{t("login_h1b")}</span>
        </h1>
        <p className="mt-5 text-base text-rox-off/80">{t("login_sub")}</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="mb-2 block text-sm font-medium">{t("email")}</span>
            <input data-testid="login-email" className="field" type="email" placeholder="thomas@email.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          </label>
          <label className="block">
            <span className="mb-2 block text-sm font-medium">{t("password")}</span>
            <input data-testid="login-password" className="field" type="password" placeholder="••••••••••" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          </label>
          {error && (
            <p data-testid="login-error" className="rounded-[4px] border border-rox-orange/50 bg-rox-orange/10 px-3 py-2 text-sm text-rox-orange">{error}</p>
          )}
          <button data-testid="login-submit" className="btn-primary" disabled={busy}>
            {busy ? "..." : t("login_btn")} <ArrowRight size={20} />
          </button>
        </form>
        <p className="mt-8 text-center text-sm text-rox-off/70">
          {t("no_account")}{" "}
          <Link to="/inscription" data-testid="login-to-signup" className="font-display uppercase tracking-wide text-rox-orange">{t("create_profile")}</Link>
        </p>
      </main>
    </AppShell>
  );
}
